<template>
  <div class="header__btns">
    <div class="header__language">
      <Lang />
    </div>
    <button
      class="header__btn-logoff"
      :class="{ 'd-none': $route.name === 'login' }"
      @click="handleClickLogout"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.345 11.345">
        <path
          id="Caminho_11985"
          data-name="Caminho 11985"
          d="M11.345,5.673h0a1.174,1.174,0,0,1-.353.84L9.035,8.441A.236.236,0,1,1,8.7,8.1l1.958-1.927a.707.707,0,0,0,.168-.268H3.073a.236.236,0,1,1,0-.473H10.83a.7.7,0,0,0-.169-.27L8.7,3.241A.236.236,0,0,1,9.035,2.9l1.958,1.925a1.174,1.174,0,0,1,.353.842h0ZM5.436,7.091a.236.236,0,0,0-.236.236V9.218a1.656,1.656,0,0,1-1.655,1.655H2.127A1.656,1.656,0,0,1,.473,9.218V2.127A1.656,1.656,0,0,1,2.127.473H3.545A1.656,1.656,0,0,1,5.2,2.127V4.018a.236.236,0,1,0,.473,0V2.127A2.13,2.13,0,0,0,3.545,0H2.127A2.13,2.13,0,0,0,0,2.127V9.218a2.13,2.13,0,0,0,2.127,2.127H3.545A2.13,2.13,0,0,0,5.673,9.218V7.327A.236.236,0,0,0,5.436,7.091Z"
          fill="#ce4646"
        />
      </svg>
      <p class="d-none d-lg-block">{{ $t("header.logoff") }}</p>
    </button>
  </div>
</template>

<script>
import Lang from "@/components/header/Lang.vue";
import { mapActions } from "vuex";

export default {
  components: {
    Lang,
  },
  methods: {
    ...mapActions(["handleLogout"]),
    async handleClickLogout() {
      try {
        const data = await this.handleLogout();

        if (data && data.logout_url) {
          // Abrir pop-up para logout
          const logoutPopup = window.open(
            data.logout_url,
            "_blank",
            "width=600,height=600"
          );

          if (logoutPopup) {
            // Fechar pop-up após 3 segundos
            setTimeout(() => {
              logoutPopup.close();

              // Limpar uuid no sessionStorage
              sessionStorage.setItem("uuid", null);

              // Redirecionar para a página de login
              this.$router.push({ name: "login" });
            }, 3000);
          } else {
            console.error(
              "Falha ao abrir o pop-up. Verifique se o navegador está bloqueando pop-ups."
            );
          }
        } else {
          console.error("Erro: logout_url não encontrado na resposta da API.");
        }
      } catch (error) {
        console.error("Erro ao fazer logout:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  &__btns {
    display: flex;
    align-items: center;
    gap: 10px;
    @media (min-width: 992px) {
      gap: 30px;
    }
  }
  &__btn-logoff {
    width: 35px;
    height: 35px;
    background: var(--color-white);
    border: 1px solid var(--color-red);
    border-radius: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    transition: 500ms;
    &:hover,
    &:focus {
      cursor: pointer;
      opacity: 0.8;
    }
    @media (min-width: 992px) {
      width: 92px;
      height: 40px;
    }
    @media (max-width: 991px) {
      gap: 0;
      padding: 0;
    }
    svg {
      width: 15px;
      height: 15px;
      @media (min-width: 992px) {
        width: 17px;
        height: 17px;
      }
    }
    p {
      font-size: 15px;
      font-family: "Font Bold";
      color: var(--color-red);
      margin-bottom: 0;
    }
  }
}
</style>
